/* -----------------UI--------------- */
import { TextInput } from "react-native-paper";

/* -----------------Third parties--------------- */

import { useAppTheme } from "@hooks/useAppTheme";
import { useTranslation } from "react-i18next";
import DeleteFormActions from "./DeleteFormActions";

type Props = {
	handleDismiss: () => void;
	selectedReasons?: string;
	handleSetFeedback: (feedback: string) => void;
	feedback: string;
	handleShowDeleteConfirmation: () => void;
};
const DeleteFeedbackForm = (props: Props) => {
	const {
		handleDismiss,
		handleSetFeedback,
		selectedReasons,
		feedback,
		handleShowDeleteConfirmation,
	} = props;
	const { t } = useTranslation();

	const handleTextChange = (text: string) => {
		handleSetFeedback(text);
	};

	const handleFormAction = (shouldDelete?: boolean) => {
		if (shouldDelete) {
			handleShowDeleteConfirmation();
		}
		handleDismiss();
	};

	const disabled = !(feedback && selectedReasons);
	const theme = useAppTheme();
	return (
		<>
			<TextInput
				placeholder={t("dialog.delete.placeholder")}
				mode="outlined"
				multiline
				onChangeText={handleTextChange}
				contentStyle={{
					minHeight: 120,
					maxHeight: 140,
				}}
				outlineStyle={{
					backgroundColor: "transparent",
				}}
				placeholderTextColor={theme.colors.onSurfaceDisabled}
			/>
			<DeleteFormActions
				handleAction={handleFormAction}
				disablePrimaryButton={disabled}
			/>
		</>
	);
};

export default DeleteFeedbackForm;
